!(function () {
  "use strict";
  const e = "[data-shopify-xr]",
    t = "[data-product-single-media-group]",
    i = "data-shopify-model3d-id";
  class s extends window.theme.DeferredMedia {
    constructor() {
      super();
    }
    loadContent() {
      super.loadContent(),
        (this.modelId = this.element.dataset.modelId),
        (this.xrButton = this.mediaContainer
          .closest(t)
          ?.parentElement.querySelector(e)),
        Shopify.loadFeatures([
          {
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
    }
    setupModelViewerUI(e) {
      e
        ? console.warn(e)
        : ((this.modelViewerUI = new Shopify.ModelViewerUI(this.element)),
          this.setupModelViewerListeners());
    }
    setupModelViewerListeners() {
      this.mediaContainer.addEventListener("theme:media:visible", () => {
        this.xrButton.setAttribute(i, this.modelId),
          window.theme.touch ||
            (this.modelViewerUI.play(),
            this.mediaContainer.dispatchEvent(
              new CustomEvent("theme:media:play"),
              { bubbles: !0 }
            ));
      }),
        this.mediaContainer.addEventListener("theme:media:hidden", () => {
          this.modelViewerUI.pause();
        }),
        this.mediaContainer.addEventListener("xrLaunch", () => {
          this.modelViewerUI.pause();
        }),
        this.element.addEventListener("load", () => {
          this.xrButton.setAttribute(i, this.modelId),
            this.mediaContainer.dispatchEvent(
              new CustomEvent("theme:media:play"),
              { bubbles: !0 }
            );
        }),
        this.element.addEventListener(
          "shopify_model_viewer_ui_toggle_play",
          () => {
            this.pauseOtherMedia(),
              setTimeout(() => {
                this.mediaContainer.dispatchEvent(
                  new CustomEvent("theme:media:play"),
                  { bubbles: !0 }
                );
              }, 50);
          }
        ),
        this.element.addEventListener(
          "shopify_model_viewer_ui_toggle_pause",
          () => {
            this.mediaContainer.dispatchEvent(
              new CustomEvent("theme:media:pause"),
              { bubbles: !0 }
            );
          }
        ),
        this.pauseOtherMedia();
    }
  }
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(e) {
      e
        ? console.warn(e)
        : window.ShopifyXR
        ? (document.querySelectorAll('[id^="ModelJson-"]').forEach((e) => {
            window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove();
          }),
          window.ShopifyXR.setupXRElements())
        : document.addEventListener("shopify_xr_initialized", () =>
            this.setupShopifyXR()
          );
    },
  }),
    window.addEventListener("DOMContentLoaded", () => {
      window.ProductModel && window.ProductModel.loadShopifyXR();
    }),
    customElements.get("product-component") ||
      customElements.define(
        "product-component",
        class extends HTMLElement {
          constructor() {
            super(),
              (this.flkty = null),
              (this.flktyNav = null),
              (this.isFlickityDragging = !1),
              (this.checkSliderOnResize = () => this.checkSlider()),
              (this.flktyNavOnResize = () => this.resizeFlickityNav());
          }
          connectedCallback() {
            if (
              ((this.container = this.closest("[data-section-type]")),
              (this.sectionId = this.getAttribute("data-section-id")),
              (this.tallLayout =
                "true" === this.getAttribute("data-tall-layout")),
              (this.featureSliders = this.querySelectorAll("[data-slider]")),
              (this.enableHistoryState =
                "featured-product" ===
                !this.container.getAttribute("data-section-type")),
              this.initUpsellSlider(),
              this.initFeatureSlider(),
              this.container.classList.contains("featured-product--onboarding"))
            )
              return;
            const e = this.querySelector("[data-product-json]");
            if (e && e.innerHTML) {
              const t = JSON.parse(e.innerHTML).handle;
              let i = {};
              t && (i = { handle: t }),
                Shopify.Products.recordRecentlyViewed(i);
            } else Shopify.Products.recordRecentlyViewed();
            this.productSlider(),
              this.initMediaSwitch(),
              this.initShopifyXrLaunch(),
              this.initVariantChangeListener();
          }
          productSlider() {
            this.checkSlider(),
              document.addEventListener(
                "theme:resize:width",
                this.checkSliderOnResize
              );
          }
          checkSlider() {
            !this.tallLayout || window.innerWidth < theme.sizes.large
              ? this.initProductSlider()
              : this.destroyProductSlider();
          }
          resizeFlickityNav() {
            null !== this.flktyNav && this.flktyNav.resize();
          }
          initProductSlider() {
            const e = this.querySelector("[data-product-single-media-slider]"),
              t = this.querySelector("[data-product-single-media-thumbs]"),
              i = this.querySelectorAll("[data-product-single-media-wrapper]");
            if (
              i.length > 1 &&
              ((this.flkty = new window.theme.Flickity(e, {
                wrapAround: !0,
                pageDots: !1,
                adaptiveHeight: !0,
                on: {
                  ready: () => {
                    this.slidesAriaHidden(e),
                      i.forEach((e) => {
                        if (!e.classList.contains("is-selected")) {
                          const t = e.querySelectorAll("a, button");
                          t.length &&
                            t.forEach((e) => {
                              e.setAttribute("tabindex", "-1");
                            });
                        }
                      });
                  },
                  dragStart: () => {
                    e.classList.add("is-moving");
                  },
                  dragMove: () => {
                    this.isFlickityDragging = !0;
                  },
                  staticClick: () => {
                    this.isFlickityDragging = !1;
                  },
                  change: () => {
                    this.slidesAriaHidden(e);
                  },
                  settle: (t) => {
                    const i =
                      this.flkty.selectedElement.getAttribute("data-media-id");
                    this.flkty.cells.forEach((e, i) => {
                      const s = e.element.querySelectorAll("a, button");
                      s.length &&
                        s.forEach((e) => {
                          e.setAttribute("tabindex", i === t ? "0" : "-1");
                        });
                    }),
                      this.switchMedia(i),
                      e.classList.remove("is-moving");
                  },
                },
              })),
              i.length &&
                i.forEach((e) => {
                  e.addEventListener("theme:media:play", () => {
                    (this.flkty.options.draggable = !1),
                      this.flkty.updateDraggable(),
                      e
                        .closest("[data-product-single-media-slider]")
                        .classList.add("has-media-active");
                  }),
                    e.addEventListener("theme:media:pause", () => {
                      (this.flkty.options.draggable = !0),
                        this.flkty.updateDraggable(),
                        e
                          .closest("[data-product-single-media-slider]")
                          .classList.remove("has-media-active");
                    });
                }),
              window.theme.flickitySmoothScrolling(e),
              null !== t)
            ) {
              this.flktyNav = new window.theme.Flickity(t, {
                asNavFor: e,
                contain: !0,
                pageDots: !1,
                prevNextButtons: !1,
                resize: !0,
                cellAlign: 'left',
                on: {
                  ready: () => {
                    t.setAttribute("tabindex", "-1"),
                      this.slidesAriaHidden(t),
                      requestAnimationFrame(this.flktyNavOnResize);
                  },
                  change: () => {
                    this.slidesAriaHidden(t);
                  },
                },
              });
              const i = () => {
                requestAnimationFrame(this.flktyNavOnResize),
                  this.flktyNav.viewport.removeEventListener(
                    "transitionend",
                    i
                  );
              };
              null !== this.flktyNav &&
                (document.addEventListener(
                  "theme:resize:width",
                  this.flktyNavOnResize
                ),
                this.flktyNav.viewport.addEventListener("transitionend", i)),
                window.theme.flickitySmoothScrolling(t);
              const s = this.querySelectorAll(
                ".product-single__thumbnail-link"
              );
              s.length &&
                s.forEach((e) => {
                  e.addEventListener("click", (e) => {
                    e.preventDefault();
                  });
                });
            }
          }
          slidesAriaHidden(e) {
            window.theme.Flickity.data(e).cells.forEach((e) =>
              e.element.setAttribute("aria-hidden", "false")
            );
          }
          destroyProductSlider() {
            null !== this.flkty &&
              (this.flkty.destroy(),
              this.flktyNav.destroy(),
              (this.flkty = null),
              (this.flktyNav = null));
          }
          initUpsellSlider() {
            const e = this.querySelector("[data-upsell-slider]"),
              t = this.querySelectorAll("[data-upsell-holder]");
            if (t.length > 1) {
              const i = new window.theme.Flickity(e, {
                wrapAround: !0,
                pageDots: !0,
                adaptiveHeight: !0,
                prevNextButtons: !1,
                on: {
                  ready: () => {
                    t.forEach((e) => {
                      if (!e.classList.contains("is-selected")) {
                        const t = e.querySelectorAll("a, button");
                        t.length &&
                          t.forEach((e) => {
                            e.setAttribute("tabindex", "-1");
                          });
                      }
                    });
                  },
                },
              });
              i.on("change", (e) => {
                i.cells.forEach((t, i) => {
                  const s = t.element.querySelectorAll("a, button");
                  s.length &&
                    s.forEach((t) => {
                      t.setAttribute("tabindex", i === e ? "0" : "-1");
                    });
                });
              });
            }
          }
          initFeatureSlider() {
            this.featureSliders.forEach((e) => {
              const t = Array.from(e.children);
              if (t.length > 1) {
                new window.theme.Flickity(e, {
                  wrapAround: !0,
                  pageDots: !0,
                  adaptiveHeight: !0,
                  prevNextButtons: !1,
                  on: {
                    ready: function () {
                      t.forEach((e) => {
                        if (!e.classList.contains("is-selected")) {
                          const t = e.querySelectorAll("a, button");
                          t.length &&
                            t.forEach((e) => {
                              e.setAttribute("tabindex", "-1");
                            });
                        }
                      });
                    },
                  },
                }).on("change", (e) => {
                  t.forEach((t, i) => {
                    const s = t.querySelectorAll("a, button");
                    s.length &&
                      s.forEach((t) => {
                        t.setAttribute("tabindex", i === e ? "0" : "-1");
                      });
                  });
                });
              }
            });
          }
          handleMediaFocus(e) {
            if (
              e.code !== theme.keyboardKeys.ENTER &&
              e.code !== theme.keyboardKeys.TAB
            )
              return;
            const t = e.currentTarget.getAttribute("data-thumbnail-id"),
              i = this.querySelector(`[data-media-id="${t}"]`),
              s = parseInt([...i.parentNode.children].indexOf(i)),
              d = this.querySelector("[data-product-single-media-slider]"),
              n = this.querySelector("[data-product-single-media-thumbs]"),
              a = window.theme.Flickity.data(d) || null,
              o = window.theme.Flickity.data(n) || null;
            a &&
              a.isActive &&
              s > -1 &&
              (e.code === theme.keyboardKeys.ENTER ||
                e.code === theme.keyboardKeys.NUMPADENTER) &&
              a.select(s),
              o && o.isActive && s > -1 && o.select(s);
          }
          switchMedia(e) {
            const t = document.querySelectorAll(
                "[data-product-single-media-wrapper]"
              ),
              i = this.querySelector(
                `[data-product-single-media-wrapper][data-media-id="${e}"]`
              ),
              s = !document.body.classList.contains("no-outline");
            t.length &&
              t.forEach((e) => {
                e.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                  bubbles: !0,
                }),
                  e.classList.add("media--hidden");
              }),
              s && i.focus(),
              i
                .closest("[data-product-single-media-slider]")
                .classList.remove("has-media-active"),
              i.classList.remove("media--hidden"),
              i.dispatchEvent(new CustomEvent("theme:media:visible"), {
                bubbles: !0,
              });
            const d = i.querySelector("[data-deferred-media]");
            d &&
              "true" !== d.getAttribute("loaded") &&
              i
                .querySelector("[data-deferred-media-button]")
                .dispatchEvent(new Event("click"));
          }
          initMediaSwitch() {
            const e = this.querySelectorAll("[data-thumbnail-id]");
            e.length &&
              e.forEach((e) => {
                e.addEventListener("keyup", this.handleMediaFocus.bind(this)),
                  e.addEventListener("click", (e) => {
                    e.preventDefault();
                  });
              });
          }
          initShopifyXrLaunch() {
            document.addEventListener("shopify_xr_launch", () => {
              this.querySelector(
                "[data-model]:not(.media--hidden)"
              ).dispatchEvent(new CustomEvent("xrLaunch"));
            });
          }
          initVariantChangeListener() {
            // Store the initial variant's color option
            this.previousColorValue = this.getCurrentColorValue();
            
            this.container.addEventListener("theme:variant:change", (e) => {
              if (e.detail && e.detail.variant) {
                this.onVariantChange(e.detail.variant);
              }
            });
          }
          getCurrentColorValue() {
            // Get the product data to find which option is the color option
            const productJson = this.querySelector("[data-product-json]");
            if (!productJson || !productJson.innerHTML) return null;

            try {
              const product = JSON.parse(productJson.innerHTML);
              
              // Find the color option index by checking option names
              // Common color option names (case-insensitive)
              const colorNames = ['color', 'colour', 'couleur', 'colore', 'farbe'];
              let colorOptionIndex = null;

              if (product.options && product.options.length) {
                product.options.forEach((optionName, index) => {
                  if (colorNames.some(name => optionName.toLowerCase().includes(name))) {
                    colorOptionIndex = index + 1; // Shopify uses option1, option2, option3
                  }
                });
              }

              // Get the current variant
              const currentVariantId = this.querySelector('[name="id"]')?.value;
              if (!currentVariantId || !colorOptionIndex) return null;

              const currentVariant = product.variants.find(v => v.id == currentVariantId);
              if (!currentVariant) return null;

              // Return the color option value (option1, option2, or option3)
              return currentVariant[`option${colorOptionIndex}`];
            } catch (error) {
              console.error("Error getting color value:", error);
              return null;
            }
          }
          async onVariantChange(variant) {
            if (!variant || !variant.id) return;

            // Get the color option from the new variant
            const productJson = this.querySelector("[data-product-json]");
            if (!productJson || !productJson.innerHTML) return;

            try {
              const product = JSON.parse(productJson.innerHTML);
              
              // Find the color option index
              const colorNames = ['color', 'colour', 'couleur', 'colore', 'farbe'];
              let colorOptionIndex = null;

              if (product.options && product.options.length) {
                product.options.forEach((optionName, index) => {
                  if (colorNames.some(name => optionName.toLowerCase().includes(name))) {
                    colorOptionIndex = index + 1;
                  }
                });
              }

              // If no color option exists, don't update gallery
              if (!colorOptionIndex) return;

              // Get the new color value
              const newColorValue = variant[`option${colorOptionIndex}`];

              // Only update gallery if the color option has changed
              if (newColorValue === this.previousColorValue) {
                return; // Color hasn't changed, skip gallery update
              }

              // Update the stored color value
              this.previousColorValue = newColorValue;

              // Fetch the product page with the new variant
              const url = `${window.location.pathname}?variant=${variant.id}&section_id=${this.sectionId}`;

              const response = await fetch(url);
              const html = await response.text();

              // Create a temporary container to parse the HTML
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = html;

              // Find the new gallery in the fetched HTML
              const newGallery = tempDiv.querySelector("[data-product-single-media-group]");
              const currentGallery = this.querySelector("[data-product-single-media-group]");

              if (newGallery && currentGallery) {
                // Destroy existing sliders before replacing content
                this.destroyProductSlider();

                // Replace the gallery content
                currentGallery.innerHTML = newGallery.innerHTML;

                // Reinitialize media switch (thumbnails click handlers)
                this.initMediaSwitch();

                // Reinitialize the product slider
                this.checkSlider();

                // The zoom-images custom element will automatically initialize
                // when it's connected to the DOM via the innerHTML replacement

                // Dispatch custom event for any other components that need to reinitialize
                this.dispatchEvent(
                  new CustomEvent("theme:product:gallery-updated", {
                    bubbles: true,
                    detail: { variant: variant },
                  })
                );

                // Reinitialize animations if enabled
                if (window.theme.settings && window.theme.settings.animationsEnabled) {
                  if (typeof window.initAnimations === "function") {
                    window.initAnimations();
                  }
                }

                // Reinitialize 3D models if present
                const models = currentGallery.querySelectorAll("product-model");
                if (models.length && window.ProductModel) {
                  window.ProductModel.loadShopifyXR();
                }
              }
            } catch (error) {
              console.error("Error updating product gallery:", error);
            }
          }
          disconnectedCallback() {
            null !== this.flktyNav &&
              document.removeEventListener(
                "theme:resize:width",
                this.flktyNavOnResize
              ),
              document.removeEventListener(
                "theme:resize:width",
                this.checkSliderOnResize
              );
          }
        }
      ),
    customElements.get("product-model") ||
      customElements.define("product-model", s);
})();
